<template>
    <div id="recruiter_new_candidates" class="flex_content" v-if='dataLoaded'>

        <div id="context_bar" :class="{no_right_button: notOwnedRef}">
            <TopbarGoRefsList/>
            <TopbarTabs/>
            <ShareRefModal :currentRef="currentRef" v-if="canEditRef" />
            <TopbarSaveBtn v-if="canEditRef"/>
        </div>

        <transition :name="stepAnim">
            <component :is="currentStepComponent" :is-new="false" :notOwnedRef="!canEditRef" ></component>
        </transition>

    </div>

</template>

<script>
import TopbarGoRefsList from "../components/topbar/topbarGoRefsList"
import TopbarTabs from "../components/topbar/topbarTabs"
import TopbarSaveBtn from "../components/topbar/topbarSaveBtn"
import ShareRefModal from "../components/form/shareRefModal"

import FormStep1 from "../components/form/formStep1"
import FormStep2 from "../components/form/formStep2"
import FormStep3 from "../components/form/formStep3"
import FormStep4 from "../components/form/formStep4"

export default {
    name: 'RefsEdit',
    components: {
        TopbarGoRefsList,
        TopbarTabs,
        TopbarSaveBtn,
        FormStep1,
        FormStep2,
        FormStep3,
        FormStep4,
        ShareRefModal
    },
    beforeCreate: function () {
        this.$store.dispatch('RefStore/indexCats', "saven")
        this.$store.dispatch('RefStore/indexRefs', "saven")
        this.$store.dispatch('RefStore/initEdit', this.$route.params.id).then(() => this.dataLoaded = true)
    },
    data(){
        return {
            stepAnim: "tab-slide-right",
            dataLoaded: false,
            userData: JSON.parse(localStorage.getItem('account')).user
        }
    },
    computed: {
        currentStepComponent(){
            return this.$store.state.RefStore.formStepsName[this.$store.state.RefStore.formCurrentStep]
        },
        currentRef(){
            return this.$store.state.RefStore.currentRef
        },
        notOwnedRef(){
            return this.userData.id != this.currentRef.user_id
        },
        shareModeActive(){
            return JSON.parse(localStorage.getItem('account')).contract.sharing_data_mode == "across_company"
        },
        canEditRef(){
            return !this.notOwnedRef || this.shareModeActive
        }
    },
    watch: {
        currentStepComponent: function(newVal, oldVal){
            const newIndex = this.$store.state.RefStore.formStepsName.indexOf(newVal)
            const oldIndex = this.$store.state.RefStore.formStepsName.indexOf(oldVal)
            if(newIndex > oldIndex){
                this.stepAnim = "tab-slide-right"
            }else{
                this.stepAnim = "tab-slide-left"
            }


        }
    },
    beforeDestroy(){
        this.$store.dispatch('RefStore/initNew')
    }
}
</script>

<style lang="scss">
    .no_right_button{
        padding-right: 90px;
    }
    .steps_nav{
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

